<script lang="ts">
	import emailSpellChecker from '@zootools/email-spell-checker/dist/index'
	import { slide } from 'svelte/transition'

	let suggested_email: undefined | string
	export let input: HTMLInputElement

	const spellcheck = () => {
		suggested_email = emailSpellChecker.run({ email: input.value })?.full
	}
	$: if (input) {
		input.addEventListener(`change`, spellcheck)
		spellcheck()

		// Only update-as-you-type if the spellcheck was already showing
		input.addEventListener(`input`, () => suggested_email && spellcheck())
	}

	const fix_email = () => {
		input.value = suggested_email!
		suggested_email = undefined
	}
</script>

{#if suggested_email}
	<div transition:slide>
		<span>Did you mean <u>{suggested_email}</u>?</span>
		<button type=button on:click={fix_email}>Fix</button>
	</div>
{/if}

<style>
	div {
		padding-top: 0.25em;
	}
	span {
		font-size: small;
	}
	button {
		padding: 0.25em 0.5em;
	}
</style>
